import script from "./UsersRegistrationTaskList.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersRegistrationTaskList.vue?vue&type=script&setup=true&lang=js"

import "./UsersRegistrationTaskList.vue?vue&type=style&index=0&id=7fd022f6&scoped=true&lang=css"
script.__scopeId = "data-v-7fd022f6"

export default script